module.exports = __webpack_public_path__ + "cc38f9a04a2f0b46e85951c5dbbff2d3.pdf";